// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3pZL0","alertIcon":"ConfirmModal_alertIcon__25RIa"};